var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"corners",attrs:{"role":"presentation","aria-hidden":""}},_vm._l((_vm.sides),function(item){return _c('span',{key:item,staticClass:"corner",class:{ [`corner--${item}`]: true, 'corner--wide': _vm.wide }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }